module.exports = __webpack_public_path__ + "static/accessibility-4a4de3f010909b292d24fd330980a427.jpg";